export default `
* {
  box-sizing: border-box;
}
p {
  margin-bottom: 24px;
}
body {
  line-height: 1.4;
  font-family: sans-serif;
}
.page {
  page-break-after: always;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 24px;
}
th {
  background-color: #d9d9d9;
  font-weight: bold;
  text-align: center;
  min-width: 100px;
}
td {
  height: 64px;
}
.homeActivityLog td {
  height: 80px;
}
td, th {
  border: 1px solid black;
  padding: 8px;
  vertical-align: top;
}
.title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
}
.reactionImageWrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reactionImage {
  height: 40px;
  object-fit: contain;
}
`